const review2026Content = {
  title: '超萬人參賽，第五屆「曾憲備・紫荊盃」全港少兒普通話朗誦比賽圓滿落幕！',
  subtitle: '',
  videoUrl:
    'https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2026-04/ef40a93a3b460f931de31b4a6b4a9c10.mp4',
  blocks: [
    {
      type: 'paragraph',
      text: '2026年4月25日，第五屆「曾憲備・紫荊盃」全港少兒普通話朗誦比賽決賽暨頒獎典禮，在東華三院曾憲備小學圓滿落幕。本次大賽特邀香港立法會議員李浩然博士MH,JP、教育局高級課程發展主任周健博士、中聯辦新界工作部宣教處副處長黃展豪先生重磅擔任活動主禮嘉賓，嘉賓陣容規格備受香港教育界、社會各界高度重視。',
    },
    {
      type: 'paragraph',
      text: '本屆比賽由曾憲備慈善基金、新界校長會及中文路（香港）有限公司聯合主辦，同時獲得活力慈善基金、梨木樹苗趣社、文冬漢語普通話中心、香港普通話專業協會多方單位協辦加持。作為香港極具代表性的少兒普通話朗誦賽事之一，「紫荊盃」自創辦以來持續深耕校園普通話普及推廣，逐步成長為香港本土集語言能力培養、文化傳承與教育實踐於一體的重要平台。',
    },
    {
      type: 'image',
      src: require('@/assets/image/web_hk2026/img_01.jpg'),
      alt: '第五屆「曾憲備・紫荊盃」比賽全場合影',
      caption: '第五屆「曾憲備・紫荊盃」比賽全場合影',
    },
    {
      type: 'section',
      title: '萬人參賽，規模跨越式增長',
    },
    {
      type: 'paragraph',
      text: '本屆比賽共吸引全港537所學校、超過10,060名學生踴躍參與，參賽規模首次突破一萬人大關，創賽事歷史新高。',
    },
    {
      type: 'paragraph',
      text: '其中，學校統一組織報名人數較去年增加5,840人，同比增長210.30%，成為本屆規模躍升的核心推動力量。越來越多學校以整體組織形式參與，使普通話學習由學生個人興趣參與，逐步走向校園層面的常態化實踐。',
    },
    { type: 'image', src: require('@/assets/image/web_hk2026/img_02.jpg'), alt: '賽事現場精彩瞬間', caption: '' },
    { type: 'image', src: require('@/assets/image/web_hk2026/img_03.jpg'), alt: '賽事現場精彩瞬間', caption: '' },
    {
      type: 'section',
      title: '多元賽制全覆蓋獎項體系全面升級',
    },
    {
      type: 'paragraph',
      text: '本屆比賽以個人賽為核心，根據學生年級細緻劃分出9個組別，並繼續設立「飛躍組」（面向非華語學生）及「閃亮組」（面向特殊教育學生），持續構建多元包容的參賽體系。',
    },
    {
      type: 'paragraph',
      text: '其中，「閃亮組」的設立充分體現賽事的教育温度與社會價值。這一組別中的學生，是一群特殊教育需要的孩子。他們能夠站上朗誦舞台，本身就展現出難得的勇氣與堅持。他們在舞台上的每一次表達，都是自信的建立與成長的呈現；每一次登台亮相，都是勇氣與堅持的真實體現。',
    },
    { type: 'image', src: require('@/assets/image/web_hk2026/img_04.jpg'), alt: '學生舞台風采', caption: '' },
    {
      type: 'paragraph',
      text: '為鼓勵學生在語言表達與舞台呈現上的綜合發展，比賽特別設立多項特色獎項，包括「最佳造型獎」、「最佳語音獎」、「最佳台風獎」。獎項體系從不同維度對學生的表現進行評價，使比賽由單一結果導向，延伸為對學生語言能力與舞台展現能力的綜合肯定。',
    },
    { type: 'image', src: require('@/assets/image/web_hk2026/img_05.jpg'), alt: '學生舞台風采', caption: '' },
    {
      type: 'section',
      title: 'AI賦能語言學習與賽事評估',
    },
    {
      type: 'paragraph',
      text: '本屆比賽在初賽階段，繼續採用了中文路自主研發的AI普通話評估技術作為輔助工具。該系統可快速處理海量參賽音訊，從聲母、韻母、聲調等維度，精准分析選手發音準確度與朗誦流暢度，實現自動評分與表現回饋，既提升評審效率，又保障評分客觀公正，還能通過資料回饋幫學生找准學習短板、優化練習。此外，中文路自研AI中文自主學習系統，搭載場景對話、看圖説話、短講訓練等功能，為學生提供個性化學習支援，助力香港中小學生提升普通話綜合應用能力。',
    },
    { type: 'image', src: require('@/assets/image/web_hk2026/img_06.jpg'), alt: 'AI語言學習展示', caption: '' },
    {
      type: 'paragraph',
      text: '決賽候場期間，我們還貼心為參賽學生打造了趣味AI互動遊戲區，將普通話學習與趣味互動深度結合，讓孩子們在輕鬆愉悅的氛圍中感受中文語言魅力，有效舒緩賽前緊張情緒，以更從容、自信的狀態迎接比賽，盡情展現自身風采。',
    },
    { type: 'image', src: require('@/assets/image/web_hk2026/img_07.jpg'), alt: 'AI互動遊戲區', caption: '' },
    {
      type: 'section',
      title: '專業評審把關多維考察見真章',
    },
    {
      type: 'paragraph',
      text: '決賽由監審主任儲安麗女士領銜的專業評審團隊負責評審工作。評審團隊成員包括：',
    },
    { type: 'line', text: '儲安麗女士——中國傳媒大學青少年口語傳播教學法教師，多次擔任香港學校戲劇節及朗誦節評審，連續四屆「曾憲備·紫荊盃」評審；' },
    { type: 'line', text: '李春紅女士——香港恒生大學高級講師、國家級普通話測試員；' },
    { type: 'line', text: '金  丹女士——香港電台主持人、前中央電視台新聞播音員；' },
    { type: 'line', text: '程梓龍先生——全國青少年口語傳播能力測評師，資深朗誦賽事評判（粵語及普通話組）；' },
    { type: 'line', text: '孫  潔女士——中華人才交流協會創始人，全港朗誦比賽資深評判；' },
    { type: 'line', text: '袁立一女士——中央電視台新聞配音背景，香港電台普通話台主持人；' },
    { type: 'line', text: '傅偉琴女士——香港普通話專業協會執行主席，國家級語言藝術考級高級講師；' },
    { type: 'line', text: '馮媛媛女士——原中央電台主持人，從事語言藝術教育逾十五年；' },
    { type: 'line', text: '楊  潔女士——全國朗誦及播音主持專業高級教師，資深語言藝術教育工作者。' },
    { type: 'image', src: require('@/assets/image/web_hk2026/img_08.jpg'), alt: '決賽評審現場', caption: '' },
    {
      type: 'paragraph',
      text: '各評審從發音標準、節奏韻律、情感表達、儀態舉止、內容理解及整體表現力等多個維度，對選手表現進行綜合評定，確保評審過程專業嚴謹、標準統一。評審階段引入了AI輔助評分工具，對流程及結果進行記錄與呈現，使評分過程更加清晰透明、可追溯。所有選手成績均由每位評委獨立評分後綜合評定，確保評審結果客觀與公正。',
    },
    {
      type: 'section',
      title: '頒獎典禮與嘉賓致辭',
    },
    {
      type: 'paragraph',
      text: '頒獎典禮上，曾憲備慈善基金董事曾慶輝先生在致辭中表示，本屆比賽在各大辦學團體及校長、老師的積極推動下，報名人數突破10,000人，再創歷史新高，並向全體參賽者致以熱烈祝賀。',
    },
    {
      type: 'paragraph',
      text: '他提到，本屆賽事引入AI技術，將學習過程轉化為可操作路徑，通過發音分析、即時回饋及專業報告，實現「24小時學習輔助」，有效提升學生自主學習能力，是教育科技融合的積極實踐。同時，他強調，普通話學習不僅有助於提升語言能力與職場競爭力，也能增強文化認同與自信，充分展現學生的語言素養與文化風貌。',
    },
    {
      type: 'image',
      src: require('@/assets/image/web_hk2026/img_09.jpg'),
      alt: '曾憲備慈善基金董事 曾慶輝先生致歡迎辭',
      caption: '曾憲備慈善基金董事 曾慶輝先生致歡迎辭',
    },
    {
      type: 'paragraph',
      text: '立法會議員李浩然博士（MH, JP）從「學習體驗與成長價值」角度肯定了本次比賽。他認為，比賽的意義不只在於成績與名次，更重要的是學生在過程中不斷突破自我、獲得成長，「每一位參賽者都是成長的贏家」。他也提到，朗誦學習不僅是語言訓練，更是一個從理解文字、感受情感，到與作者及觀眾產生共鳴的過程，讓語言學習變得更立體、更有温度。',
    },
    {
      type: 'image',
      src: require('@/assets/image/web_hk2026/img_10.jpg'),
      alt: '立法會議員李浩然 博士（MH,JP）致辭',
      caption: '立法會議員李浩然 博士（MH,JP）致辭',
    },
    {
      type: 'paragraph',
      text: '中文路（香港）有限公司執行總裁姚凱先生在致辭中代表主辦方向各支援單位及工作人員致謝，並談到在AI時代，語言能力的價值正在被重新定義。',
    },
    {
      type: 'paragraph',
      text: '他認為，AI的底層邏輯是語言，而中文正逐漸成為連接未來科技的重要基礎能力。普通話不只是溝通工具，更像是一種面向未來的能力體系，關係到學生長期的發展與競爭力。中文路將持續通過AI推動教學創新，打通學習與就業之間的連接，並以公益賽事推動語言教育發展，使「紫荊盃」逐步成為香港規模最大的普通話賽事之一。',
    },
    {
      type: 'image',
      src: require('@/assets/image/web_hk2026/img_11.jpg'),
      alt: '中文路（香港）有限公司執行總裁姚凱先生致謝辭',
      caption: '中文路（香港）有限公司執行總裁姚凱先生致謝辭',
    },
    {
      type: 'section',
      title: '致謝嘉賓及支持機構',
    },
    {
      type: 'paragraph',
      text: '本次頒獎典禮榮幸邀請到以下主禮嘉賓出席活動：立法會議員李浩然博士（MH, JP），教育局高級課程發展主任（中文）周健博士，中聯辦新界工作部宣教處副處長黃展豪先生，曾憲備慈善基金董事曾慶輝先生，新界校長會副會長邱少雄校長（MH），中文路（香港）有限公司執行總裁姚凱先生，中文路（香港）有限公司董事陳宇虹女士，梨木樹苗趣社劉松剛區議員，文冬漢語普通話中心李宇軒先生，香港普通話專業協會靳彤彤區議員，香港教育中心商會李俊康先生，曾憲備慈善基金陳艷經理，活力慈善基金會務顧問郭玲麗女士、活力慈善基金董事李惠芳女士。',
    },
    { type: 'image', src: require('@/assets/image/web_hk2026/img_12.jpg'), alt: '主禮嘉賓合照', caption: '' },
    {
      type: 'paragraph',
      text: '同時，本屆賽事亦得到了以下機構的大力支持與協助：民建聯、香港教師會、東華三院曾憲備小學、香港教育中心商會、北京廣播電視台北京廣播影視培訓中心、香港浙江省同鄉會聯合會、香港福建社團聯會新界東北分會，以及朱偉林區議員辦事處、劉松剛區議員辦事處、靳彤彤區議員辦事處、李細燕區議員辦事處、邱少雄區議員辦事處、林翠玲區議員辦事處、周劍豪區議員辦事處、陳孟宜區議員辦事處、陳曉津區議員辦事處及香港國際青少兒交流協會及支持媒體MameShare。',
    },
    {
      type: 'image',
      src: require('@/assets/image/web_hk2026/img_13.jpg'),
      alt: '左一：郭玲麗女士，右一：黃展豪副處長',
      caption: '左一：郭玲麗女士，右一：黃展豪副處長',
    },
    {
      type: 'paragraph',
      text: '為表彰對本屆「曾憲備・紫荊盃」全港少兒普通話朗誦比賽長期推動與組織工作的傑出貢獻，比賽特別頒發「特別貢獻獎」，以感謝朗誦比賽牽頭人郭玲麗女士在賽事策劃、推動及發展過程中所作出的重要貢獻。感謝郭玲麗女士對賽事的持續投入與支持，使「紫荊盃」得以不斷發展壯大，成為香港具有代表性的少兒普通話朗誦賽事之一。',
    },
    {
      type: 'paragraph',
      text: '感謝以上主禮嘉賓及支持機構對第五屆「曾憲備・紫荊盃」全港少兒普通話朗誦比賽的支持，使賽事得以順利舉行並持續提升專業水準與社會影響力。',
    },
    {
      type: 'paragraph',
      text: '回顧五屆發展歷程，「曾憲備・紫荊盃」全港少兒普通話朗誦比賽在持續擴大參與規模的同時，也逐步成為學校開展普通話實踐教學的重要平台，使語言學習從課堂走向更真實的表達場景。',
    },
    {
      type: 'paragraph',
      text: '未來，中文路將緊扣香港校園普通話教學實際需求，探索更貼近校園教學的實踐路徑，借助AI等技術手段優化學習支援與回饋機制，助力學校提升普通話教學成效。讓更多學生在賽事實踐中提升普通話水平、建立語言自信，持續推動普通話在香港校園的普及與長遠發展。',
    },
    { type: 'image', src: require('@/assets/image/web_hk2026/img_14.jpg'), alt: '活動現場照片', caption: '' },
    {
      type: 'section',
      title: '第五屆朗誦比賽獲獎名單公示',
    },
    { type: 'awards' },
    {
      type: 'section',
      title: '掃碼關注',
      compact: true,
    },
    {
      type: 'image',
      src: require('@/assets/image/web_hk2026/img_15.png'),
      alt: '掃碼關注',
      caption: '',
    },
  ],
  awardGroups: [
    { group: '閃亮組', awards: ['金獎：許銘賢', '銀獎：楊大福', '銅獎：吳玥瑾', '優異獎：黃子雲、譚梓泳、吳素馨'] },
    { group: '飛躍 - 幼稚園組（非華語）', awards: ['金獎：張婷婷', '銀獎：羅梓傑', '銅獎：郭柏賢', '優異獎：羅梓晴、高艾娜、lumisa Thapa'] },
    { group: '幼稚園初級組（K1-K2）', awards: ['金獎：魏家沛', '銀獎：王詩琳、陳欣芸', '銅獎：游雅媛、黃慕恆、馬樂賢', '優異獎：徐艾辰、李文采、顏語瑞、何玥蓉'] },
    { group: '幼稚園高級組（K3）', awards: ['金獎：杜祉穎', '銀獎：高研芯、潘承佑', '銅獎：劉星瑤、石智宇、董鈺瑩', '優異獎：沈因時、韋昊瑜、李沐苒、肖芊玥'] },
    { group: '小學初級組（P1-P2）', awards: ['金獎：江韋孜', '銀獎：張凱傑、梁鈞甯', '銅獎：張芊雪、陸憬翌、袁梓菡', '優異獎：韓悦晴、余梓瑤、蘇珮博、梁浚桻'] },
    { group: '小學中級組（P3-P4）', awards: ['金獎：周天易', '銀獎：李芃萱、徐洛晞', '銅獎：葉峻銘、陳欣妤、周思遠', '優異獎：李凌菲、黎睿知、徐嘉躍、何曾柳'] },
    { group: '小學高級組（P5-P6）', awards: ['金獎：陳旺田', '銀獎：林玨鋒、陳梓琳', '銅獎：蔡鎬宇、羅樂誠、盛糖', '優異獎：彭一心、方敏祺'] },
    { group: '飛躍 - 中學組（非華語）', awards: ['金獎：娜薇雅', '銀獎：尚康賢', '銅獎：NARAYANAN Vishwa', '優異獎：馮晉、龔芷澄、Kim kyungbin'] },
    { group: '中學組（S1-S6）', awards: ['金獎：王睿澤', '銀獎：王語淇、徐姜屹', '銅獎：王婧琪、劉子清、張雅婷', '優異獎：黎渃源、郭雯欣、譚天'] },
  ],
};

export default review2026Content;
